/****
 * 工具类
 */
import api from "@/api";
import router from "@/router";
import moment from "moment";
import Store from "../store";

const Utils = {
    /**
     * 对象的深度拷贝
     * @param data 需要拷贝的元数据
     * @return {any} 返回拷贝后的新数据
     */
    deepClone(data) {
        const type = this.getType(data);
        let obj;
        if (type === "array") {
            obj = [];
        } else if (type === "object") {
            obj = {};
        } else {
            //不再具有下一层次
            return data;
        }
        if (type === "array") {
            for (let i = 0, len = data.length; i < len; i++) {
                obj.push(this.deepClone(data[i]));
            }
        } else if (type === "object") {
            for (let key in data) {
                obj[key] = this.deepClone(data[key]);
            }
        }
        return obj;
    },

    /**
     * 判断对象类型
     * @param {Object} object
     * @return {String} object type
     */
    getType(object) {
        let toString = Object.prototype.toString;
        let map = {
            "[object Boolean]": "boolean",
            "[object Number]": "number",
            "[object String]": "string",
            "[object Function]": "function",
            "[object Array]": "array",
            "[object Date]": "date",
            "[object RegExp]": "regExp",
            "[object Undefined]": "undefined",
            "[object Null]": "null",
            "[object Object]": "object"
        };
        if (object instanceof Element) {
            return "element";
        }
        return map[toString.call(object)];
    },
    /**
     * 接口数据返回后处理赋值
     * @param {Array} arr 页面所需字段列表
     * @param {Object} obj 接口获得的数据
     * @return {Object} 页面所需的数据
     */
    getRequestData(arr = [], obj = {}) {
        if (arr.length < 1) {
            return obj;
        } else if (JSON.stringify(obj) === "{}") {
            arr.forEach(el => {
                obj[el] = "";
            });
            return obj;
        } else {
            let data = {};
            arr.forEach(el => {
                data[el] = obj[el] + "";
            });
            return data;
        }
    },
    /**
     *
     * 获取url里面的某个字段的值
     *
     */
    queryStringURL(name) {
        console.log(name)
        let splitOne = window.location.href.split("#");
        if (splitOne[0].indexOf("&") != -1) {
            let splitTwo = splitOne[0].split("?");
            let vars = splitTwo[1].split("&");
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                if (pair[0] == name) {
                    return pair[1];
                }
            }
            return (false)
        } else {
            return (false)
        }
    },
    queryStringNormalURL(name) {
        console.log(name)
        let splitOne = window.location.href.split("#");
        if (splitOne[1].indexOf("&") != -1) {
            let splitTwo = splitOne[1].split("?");
            let vars = splitTwo[1].split("&");
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                if (pair[0] == name) {
                    return pair[1];
                }
            }
            return (false)
        } else {
            return (false)
        }
    },
    /**
     * 获取连接里的参数
     * @param {getQueryVariable} variable
     */
    getQueryVariable(variable) {
        var query = window.location.href;
        query = query.split("?")[1];
        var vars = query.split("&");
        for(var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if(pair[0] == variable) {
                return pair[1];
            }
        }
        return(false);
    },
    /**
     *
     * 删除url里面的某个字段的值
     *
     */
    delQueryValue(name) {
        var url = window.location.href;
        var urlArr = url.split('?');
        console.log(urlArr)
        if (urlArr.length > 1 && urlArr[1].indexOf(name) > -1) {
            var query = urlArr[1];
            var obj = {}
            var arr = query.split("&");
            for (var i = 0; i < arr.length; i++) {
                arr[i] = arr[i].split("=");
                obj[arr[i][0]] = arr[i][1];
            }
            ;
            delete obj[name];
            var urlte = urlArr[0] + '?' + JSON.stringify(obj).replace(/[\"\{\}]/g, "").replace(/\:/g, "=").replace(/\,/g, "&");
            return urlte;
        } else {
            return url;
        }
        ;
    },

    formatNumber(n) {
        n = n.toString()
        return n[1] ? n : '0' + n
    },

    //高德转百度
    tobdMap(gg_lng, gg_lat) {
        let X_PI = Math.PI * 3000.0 / 180.0;
        let x = gg_lng, y = gg_lat;
        let z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * X_PI);
        let theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * X_PI);
        let bd_lng = z * Math.cos(theta) + 0.0065;
        let bd_lat = z * Math.sin(theta) + 0.006;
        return {
            bd_lat: bd_lat,
            bd_lng: bd_lng
        };
    },
    //百度转高德
    bd_decrypt(bd_lng, bd_lat) {
        let X_PI = Math.PI * 3000.0 / 180.0;
        let x = bd_lng - 0.0065;
        let y = bd_lat - 0.006;
        let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * X_PI);
        let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * X_PI);
        let gg_lng = z * Math.cos(theta);
        let gg_lat = z * Math.sin(theta);
        return {lng: gg_lng, lat: gg_lat}
    },
    /**
     * 时间格式转换
     * @param {Object} num 格式1582732800
     * @return {Object} 页面所需的数据
     */
    timeStampChange(num) {
        let numStr = num * 1000;
        numStr = new Date(numStr);

        let year = numStr.getFullYear().toString();
        let month = (numStr.getMonth() + 1).toString();
        let date = numStr.getDate().toString();
        if (month.length == 1) {
            month = "0" + month;
        }
        if (date.length == 1) {
            date = "0" + date;
        }
        return [year, month, date].join("-");
    },
    /**
     * 保留一位小数
     */

    toDecimal2(num) {
        let f = parseFloat(num);
        if (isNaN(f)) {
            return false;
        }
        // let f = Math.round(num)/100;
        let s = f.toString();
        let rs = s.indexOf('.');
        if (rs < 0) {
            rs = s.length;
            s += '.';
        }
        while (s.length <= rs + 1) {
            s += '0';
        }
        return s;
    },
    /**
     * 保留一位小数
     */
    numbers(num) {
        num = num.toString();
        num.length > 1 ? num : num = '0' + num
        return num;
    },
    // 保留小数点
    fomatFloat(num, n) {
        /**
         * n，传入1就是一位小数，2就是两位小数
         */
        var f = parseFloat(num);

        if (isNaN(f)) {
            return false;
        }
        f = Math.round(num * Math.pow(10, n)) / Math.pow(10, n); // n 幂 向上取整
        var s = f.toString();
        var rs = s.indexOf('.');
        //判定如果是整数，增加小数点再补0
        if (rs < 0) {
            rs = s.length;
            s += '.';
        }
        while (s.length <= rs + n) {
            s += '0';
        }
        return s;
    },
    //判断token是否失效
    checkToken() {
        return new Promise((resolve, reject) => {
            if (sessionStorage.requestTime) {
                let storageTime = sessionStorage.requestTime;
                let date = parseInt(moment(new Date()).valueOf() / 1000);
                let expiresIn = sessionStorage.expires_in;//规定token 过期时间
                let diff = date - storageTime * 1;//相差秒数
                if (expiresIn * 1 - diff < 1800) {
                    api.index.getRefreshToken().then((res) => {
                        sessionStorage.access_token = res.access_token;
                        sessionStorage.refresh_token = res.refresh_token;
                        let date = parseInt(moment(new Date()).valueOf() / 1000);
                        sessionStorage.requestTime = date;//请求token 的时间
                        setTimeout(()=>{
                            resolve(true)
                        },300)
                    })
                } else {
                    resolve(true)
                }
            } else {
                resolve(true)
            }
        })
    },
    /**
     * 微信选择图片格式转换
     */
    toBase64(file) {
        console.log(file,"fileformchoose---------------")
        return new Promise((resolve, reject) => {
            wx.getLocalImgData({
                localId: file, // 图片的localID
                success: function (res) {
                    var localData = res.localData; // localData是图片的base64数据，可以用img标签显示
                    if (localData.indexOf('data:image') != 0) {
                        //判断是否有这样的头部
                        localData = 'data:image/jpeg;base64,' + localData;
                    }
                    localData = localData.replace(/\r|\n/g, '').replace('data:image/jgp', 'data:image/jpeg'); // 此处的localData 就是你所需要的base64位
                    resolve(localData);
                }
            });
        })
    },
    /**
     * base64转file
     */
    base64ToFile(base64) {
        var arr = base64.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], "_file_", { type: mime });
    },
    /**
     * blob转file
     */
    blobToFile(blob) {
        return new File([blob], 'file.png', { type: 'image/png', lastModified: Date.now() });
    }
};

export default Utils;
